const tangentShopIsoElement = document.getElementById("tangent-shop-iso");

if (tangentShopIsoElement) {
  const lang_code = tangentShopIsoElement.value.trim().toUpperCase();

  const updatePageTitle = (lang_code) => {
    const titles = {
      DE: "Haar-Test — Moroccanoil",
      GR: "Τεστ Μαλλιών — Moroccanoil",
      FR: "Diagnostic Cheveux — Moroccanoil",
      IT: "Hair Quiz — Moroccanoil",
      ES: "Test de Pelo — Moroccanoil",
      AT: "Haar-Test — Moroccanoil",
      NL: "Hair Quiz — Moroccanoil",
      EL: "Τεστ Μαλλιών — Moroccanoil",
    };

    const pageTitle = titles[lang_code] || "Hair Quiz — Moroccanoil";
    document.title = pageTitle;
  };

  updatePageTitle(lang_code);
} else {
  console.warn("Element #tangent-shop-iso not found.");
}

function updateProgressBar(present, total) {
    let progressBar = document.getElementById("progress-bar");
    if (present != 0) {
        progressBar.style.width = ((present - 1) / (total - 1)) * 100 + "%";
    }
}
function addQuestionDots(count) {
    const dotsContainer = document.getElementById("dots-container");
    for (let i = 0; i < count; i++) {
        let dot = document.createElement("div");
        dot.classList.add("dots");
        if (i == 0) {
            dot.classList.add("dots-active");
        }
        dot.innerHTML = "&nbsp;";
        dotsContainer.appendChild(dot);
    }
}

// Function to update active dot based on present question number
function updateActiveDot(present) {
    const dotElements = document.getElementsByClassName("dots");
    for (let i = 0; i < dotElements.length; i++) {
        if (i <= present - 1) {
            setTimeout(() => {
                dotElements[i].classList.add("dots-active");
            }, 150);
        } else {
            dotElements[i].classList.remove("dots-active");
        }
    }
}

window.addEventListener("quiz_progress", (event) => {
    let progressData = event.detail.split("_");
    let presentQuestion = Number(progressData[0]); //current question index
    let totalQuestion = Number(progressData[1]); // total number of questions

    let progressBar = document.getElementById("progress-bar-block");
    let quiz = document.getElementById("tangent-main-container");
    let image = document.getElementById("image-container");

    updateProgressBar(presentQuestion, totalQuestion);

    if (presentQuestion != "0") {
        image.style.display = "none";
        progressBar.style.display = "block";
    }
    if (presentQuestion == "0") {
        image.style.display = "block";
        progressBar.style.display = "none";
    }

    // Check if dots are already added, otherwise add them
    let dotElement = document.getElementsByClassName("dots");
    if (dotElement.length == 0) {
        addQuestionDots(totalQuestion);
    }
    // Update active dot based on the present question
    updateActiveDot(presentQuestion);
});